import {
  Home,
  User,
  LifeBuoy,
  MessageCircle,
  LogOut,
  Shield,
  BookOpen,
  FileCheck2,
  BookOpenText,
  CalendarDays,
  Files,
  FileChartColumn,
  CalendarRange,
  BookCheck,
  SquarePen,
  ServerCog,
  BookMarked,
  NotebookTabs,
  Linkedin,
  UserSearch,
  FileSearch,
  Archive,
  Languages,
  FileText,
  Sparkles,
  Mic,
  File,
  ListOrdered,
  Eraser,
  StickyNote,
  Newspaper,
  MessageSquare,
  Combine,
  FileMinus2,
} from "lucide-react";

const ROUTES = {
  OVERVIEW: "/overview",
  NEUROLOGICAL_RESEARCH: "/neurolawgical-research",
  LEGAL_VAULT: "/legal-vault",
  // SUBSCRIBE_CASES: "/cases",
  // CALENDAR: "/calendar",
  // JUDGEMENT_FINDER: "/judgement-finder",
  LEGAL_RESEARCH: "/legal-research",
  // DOCUMENT_REVIEW: "/document-review",
  DOCUMENT_ANALYZER: "/document-analyzer",
  EVENT_EXTRACTION: "/event-extraction",
  // DOCUMENT_DRAFTING: "/choose-drafting-method",
  // CUSTOM_DRAFT: "/custom-draft",
  // DRAFT_PRO: "/draftpro", 
  USER_PROFILE_COMPLETION: "/user-profile-completion",
  PROFILE: "/profile",
  USER_WALLET: "/wallet",
  FEATURES_PAGE: "/",
  LOGIN: "/login",
  PRIVACY_POLICY: "/privacy-policy",
  TERMS_OF_SERVICE: "/terms-of-service",
  DISCLAIMER: "/disclaimer",
  // CHOOSE_DRAFTING_METHOD: "/choose-drafting-method",
  // LINKEDIN_POST_GENERATOR: "/linkedin-post-generator",
  // AUDIO_TRANSCRIPTION: "/audio-transcription",
  SCANNED_COPY: "/scanned-copy",
  SCANNED_COPY_VIEW: "/scanned-copy/view/:documentId",
  TRANSLATOR: "/translator",
  TRANSLATOR_VIEW: "/translator/view/:documentId",
  PDF_TOOLS: "/pdf-tools",
  PAGINATE: "/paginate",
  ERASE: "/erase",
};

export const mainMenuItems = [
  {
    id: "NeurolawgicalResearch",
    icon: UserSearch,
    label: "Judgement Research",
    path: ROUTES.NEUROLOGICAL_RESEARCH,
    isNeurolawResearch: true,
  },
];

// export const craftDraftMenu = {
//   id: "craft-draft",
//   label: "Drafting",
//   icon: SquarePen,
//   path: ROUTES.CHOOSE_DRAFTING_METHOD,
// };

export const MobileMainMenuItems = [
  {
    id: "NeurolawgicalResearch",
    icon: UserSearch,
    label: "Judgement Research",
    path: ROUTES.NEUROLOGICAL_RESEARCH,
    isNeurolawResearch: true,
  },
  { id: "LegalVault", icon: Archive, label: "Vault", path: ROUTES.LEGAL_VAULT },
  // { id: craftDraftMenu.id, icon: craftDraftMenu.icon, label: craftDraftMenu.label, path: craftDraftMenu.path },
];

export const documentAnalysisMenu = {
  id: "document-analysis",
  label: "Docuvisor",
  icon: Files,
  items: [
    {
      id: "DocumentReview",
      icon: FileSearch,
      label: "Document Review",
      path: ROUTES.DOCUMENT_REVIEW,
    },
    {
      id: "DocumentAnalyzer",
      icon: FileChartColumn,
      label: "Document Analyzer",
      path: ROUTES.DOCUMENT_ANALYZER,
    },
    {
      id: "EventExtraction",
      icon: CalendarRange,
      label: "List of Dates",
      path: ROUTES.EVENT_EXTRACTION,
    },
    {
      id: "ScannedCopy",
      icon: BookCheck,
      label: "True Type",
      path: ROUTES.SCANNED_COPY,
    },
    {
      id: "Translator",
      icon: Languages,
      label: "Translator",
      path: ROUTES.TRANSLATOR,
    },
  ],
};

// export const supportingToolsMenu = {
//   id: "supporting-tools",
//   label: "Tools",
//   icon: ServerCog,
//   items: [
//     {
//       id: "JudgementFinder",
//       icon: BookMarked,
//       label: "Judgements",
//       path: ROUTES.JUDGEMENT_FINDER,
//     },
//     {
//       id: "LegalResearch",
//       icon: NotebookTabs,
//       label: "Acts",
//       path: ROUTES.LEGAL_RESEARCH,
//     },
//     {
//       id: "LinkedInPostGenerator",
//       icon: Linkedin,
//       label: "LinkedIn Post Generator",
//       path: ROUTES.LINKEDIN_POST_GENERATOR,
//     },
//   ],
// };

// export const casesMenu = {
//   id: "cases",
//   label: "Cases",
//   icon: BookOpenText,
//   items: [
//     {
//       id: "SubscribeCases",
//       icon: FileCheck2,
//       label: "Case Management",
//       path: ROUTES.SUBSCRIBE_CASES,
//     },
//     {
//       id: "CauseList",
//       icon: CalendarDays,
//       label: "Cause List",
//       path: ROUTES.CALENDAR,
//     },
//   ],
// };

export const documentAnalyzerFeaturesMenu = {
  id: "document-analyzer-features",
  label: "Analyze Documents",
  icon: FileChartColumn,
  items: [
    {
      id: "BriefNotes",
      icon: StickyNote,
      label: "Brief Notes",
      path: `${ROUTES.DOCUMENT_ANALYZER}?feature=brief-notes`,
    },
    {
      id: "CustomPrompt",
      icon: Sparkles,
      label: "Custom Prompt",
      path: `${ROUTES.DOCUMENT_ANALYZER}?feature=custom-prompt`,
    },
    {
      id: "AskQuestions",
      icon: MessageSquare,
      label: "Ask Questions",
      path: `${ROUTES.DOCUMENT_ANALYZER}?feature=ask-questions`,
    },
  ],
};

export const pdfToolsMenu = {
  id: "pdf-tools",
  label: "PDF Tools",
  icon: File,
  items: [
    {
      id: "Paginate",
      icon: ListOrdered,
      label: "Paginate",
      path: ROUTES.PAGINATE,
    },
    {
      id: "Erase",
      icon: Eraser,
      label: "Erase",
      path: ROUTES.ERASE,
    },
    {
      id: "MergePdf",
      icon: Combine,
      label: "Merge PDF",
      path: "/merge-pdf",
    },
    {
      id: "RemovePages",
      icon: FileMinus2,
      label: "Remove Pages",
      path: "/remove-pages",
    },
  ],
};

export const legalVaultMenu = {
  id: "legal-vault",
  label: "Vault",
  icon: Archive,
  path: ROUTES.LEGAL_VAULT,
};

// export const desktopNavMenus = [supportingToolsMenu];

export const orderedNavItems = [
  { type: "link", item: { id: "Nora", icon: Sparkles, label: "Nora", path: "/" } },
  {
    type: "link",
    item: mainMenuItems.find((item) => item.id === "NeurolawgicalResearch"),
  },
  // { type: "dropdown", menu: casesMenu },
  { type: "link", item: { id: "EventExtraction", icon: CalendarRange, label: "List of Dates", path: ROUTES.EVENT_EXTRACTION } },
  // { type: "link", item: { id: "DocumentReview", icon: FileSearch, label: "Review Documents", path: ROUTES.DOCUMENT_REVIEW } },
  { type: "link", item: { id: "DocumentAnalyzer", icon: FileChartColumn, label: "Analyze Documents", path: ROUTES.DOCUMENT_ANALYZER } },
  { type: "link", item: { id: "BriefNotes", icon: StickyNote, label: "Brief Notes", path: `${ROUTES.DOCUMENT_ANALYZER}?feature=brief-notes` } },
  { type: "link", item: { id: "CustomPrompt", icon: Sparkles, label: "Custom Prompt", path: `${ROUTES.DOCUMENT_ANALYZER}?feature=custom-prompt` } },
  { type: "link", item: { id: "AskQuestions", icon: MessageSquare, label: "Ask Questions", path: `${ROUTES.DOCUMENT_ANALYZER}?feature=ask-questions` } },
  { type: "link", item: { id: "Translator", icon: Languages, label: "Translate Documents", path: ROUTES.TRANSLATOR } },
  { type: "link", item: { id: "ScannedCopy", icon: BookCheck, label: "True Typing", path: ROUTES.SCANNED_COPY } },
  { type: "dropdown", menu: pdfToolsMenu },
  // { type: "link", item: { id: "PdfPagination", icon: ListOrdered, label: "Pagination", path: ROUTES.PAGINATE } },
  // { type: "link", item: { id: "PdfErase", icon: Eraser, label: "Erase", path: ROUTES.ERASE } },
  // { type: "link", item: { id: "AudioTranscription", icon: Mic, label: "Audio Transcription", path: ROUTES.AUDIO_TRANSCRIPTION } },
  // { type: "link", item: craftDraftMenu },
  { type: "link", item: legalVaultMenu },
  // { type: "dropdown", menu: supportingToolsMenu },
];

export const userMenuItems = (actions) => [
  {
    id: "Profile",
    icon: User,
    label: "Profile",
    action: actions.Profile,
  },
  {
    id: "Overview",
    icon: Home,
    label: "Analytics",
    action: actions.overview,
  },
  // { id: "Wallet", icon: Wallet, label: "Wallet", action: actions.wallet },
  {
    id: "Help",
    icon: LifeBuoy,
    label: "Help & Support",
    action: () => {},
    isDropdown: true,
  },
  {
    id: "Feedback",
    icon: MessageCircle,
    label: "Feedback",
    action: actions.feedback,
  },
  {
    id: "Logout",
    icon: LogOut,
    label: "Logout",
    action: actions.logout,
    isDestructive: true,
  },
];

export const helpAndSupportMenu = {
  id: "help-support",
  label: "Help & Support",
  icon: LifeBuoy,
  items: [
    {
      id: "PrivacyPolicy",
      label: "Privacy Policy",
      path: ROUTES.PRIVACY_POLICY,
      icon: Shield,
    },
    {
      id: "TermsOfService",
      label: "Terms of Service",
      path: ROUTES.TERMS_OF_SERVICE,
      icon: BookOpen,
    },
    {
      id: "Disclaimer",
      label: "Disclaimer",
      path: ROUTES.DISCLAIMER,
      icon: FileText,
    },
  ],
};

export const mobileMenuSections = [
  // { ...supportingToolsMenu, defaultOpen: false },
  // { ...casesMenu, defaultOpen: false },
  { ...pdfToolsMenu, defaultOpen: false },
  { ...helpAndSupportMenu, defaultOpen: false },
];

export const mobileSingleItems = [
  // { id: "DocumentReview", icon: FileSearch, label: "Document Review", path: ROUTES.DOCUMENT_REVIEW },
  { id: "DocumentAnalyzer", icon: FileChartColumn, label: "Document Analyzer", path: ROUTES.DOCUMENT_ANALYZER },
  { id: "EventExtraction", icon: CalendarRange, label: "List of Dates", path: ROUTES.EVENT_EXTRACTION },
  { id: "ScannedCopy", icon: BookCheck, label: "True Type", path: ROUTES.SCANNED_COPY },
  { id: "Translator", icon: Languages, label: "Translator", path: ROUTES.TRANSLATOR },
  // { id: "AudioTranscription", icon: Mic, label: "Audio Transcription", path: ROUTES.AUDIO_TRANSCRIPTION },
];
